// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-text-paper__title {
  color: var(--g-color-text-secondary);
}
.template-text-paper__content {
  position: relative;
  white-space: pre-wrap;
  padding: 8px 15px;
  background-color: var(--g-color-base-generic);
  border-radius: 5px;
  overflow: auto;
  margin: 8px 0 10px;
  font-family: var(--g-text-code-font-family);
  font-size: var(--g-text-code-1-font-size);
  line-height: var(--g-text-code-1-line-height);
}
.template-text-paper__clipboard-button {
  position: absolute;
  top: 5px;
  right: 5px;
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/TemplateTextPaper/TemplateTextPaper.scss"],"names":[],"mappings":"AACI;EACI,oCAAA;AAAR;AAGI;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;AADR;AAII;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oCAAA;AAFR","sourcesContent":[".template-text-paper__title {\n  color: var(--g-color-text-secondary);\n}\n.template-text-paper__content {\n  position: relative;\n  white-space: pre-wrap;\n  padding: 8px 15px;\n  background-color: var(--g-color-base-generic);\n  border-radius: 5px;\n  overflow: auto;\n  margin: 8px 0 10px;\n  font-family: var(--g-text-code-font-family);\n  font-size: var(--g-text-code-1-font-size);\n  line-height: var(--g-text-code-1-line-height);\n}\n.template-text-paper__clipboard-button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: var(--g-color-text-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
